/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('speedTest', speedTest);
});

function speedTest() {
  return {
    inputUrl: '',
    strategy: 'mobile',
    loading: false,
    loadingMsg: 'Testing…',
    _timer: null,
    _elapsed: 0,
    error: null,
    results: null,

    _loadingMessages: [
      { at:  0, msg: 'Testing…' },
      { at:  5, msg: 'Loading your site…' },
      { at: 10, msg: 'Running tests… 🏃🏻‍♀️' },
      { at: 15, msg: 'Time for a coffee ☕' },
      { at: 20, msg: 'Thinking…' },
      { at: 25, msg: 'Nearly there…' },
      { at: 32, msg: 'Hang on, this one\'s a workout…' },
      { at: 42, msg: 'Huzzahh !' },
    ],

    _startTimer() {
      this._elapsed = 0;
      this.loadingMsg = this._loadingMessages[0].msg;
      this._timer = setInterval(() => {
        this._elapsed += 1;
        const next = [...this._loadingMessages].reverse().find(m => this._elapsed >= m.at);
        if (next) this.loadingMsg = next.msg;
      }, 1000);
    },

    _stopTimer() {
      clearInterval(this._timer);
      this._timer = null;
      this._elapsed = 0;
    },

    async runTest() {
      this.error = null;
      this.results = null;
      this.loading = true;
      this._startTimer();

      try {
        const res = await fetch(
          `/tools/pagespeed?url=${encodeURIComponent(this.inputUrl)}&strategy=${this.strategy}`
        );
        const data = await res.json();

        if (!res.ok || data.error) {
          const errMsg = data.error?.message ?? data.error ?? `Request failed (${res.status})`;
          throw new Error(typeof errMsg === 'string' ? errMsg : JSON.stringify(errMsg));
        }

        const lhr = data.lighthouseResult;
        const audits = lhr.audits;
        const score = Math.round(lhr.categories.performance.score * 100);

        this.results = {
          url: this.inputUrl,
          score,
          metrics: [
            { id: 'fcp', label: 'First Contentful Paint',   value: audits['first-contentful-paint']?.displayValue,     rating: this.rate(audits['first-contentful-paint']?.score) },
            { id: 'lcp', label: 'Largest Contentful Paint', value: audits['largest-contentful-paint']?.displayValue,   rating: this.rate(audits['largest-contentful-paint']?.score) },
            { id: 'tbt', label: 'Total Blocking Time',      value: audits['total-blocking-time']?.displayValue,        rating: this.rate(audits['total-blocking-time']?.score) },
            { id: 'cls', label: 'Cumulative Layout Shift',  value: audits['cumulative-layout-shift']?.displayValue,    rating: this.rate(audits['cumulative-layout-shift']?.score) },
            { id: 'si',  label: 'Speed Index',              value: audits['speed-index']?.displayValue,                rating: this.rate(audits['speed-index']?.score) },
            { id: 'tti', label: 'Time to Interactive',      value: audits['interactive']?.displayValue,                rating: this.rate(audits['interactive']?.score) },
          ],
        };
      } catch (err) {
        this.error = err.message;
      } finally {
        this._stopTimer();
        this.loading = false;
      }
    },

    rate(score) {
      if (score >= 0.9) return 'Good';
      if (score >= 0.5) return 'Needs Work';
      return 'Poor';
    },

    scoreClass(score) {
      if (score >= 90) return 'report-good';
      if (score >= 50) return 'report-warning';
      return 'report-poor';
    },

    scoreLabelClass(score) {
      if (score >= 90) return 'report-good';
      if (score >= 50) return 'report-warning';
      return 'report-poor';
    },

    scoreLabel(score) {
      if (score >= 90) return 'Good';
      if (score >= 50) return 'Needs Improvement';
      return 'Poor';
    },

    scoreStroke(score) {
      if (score >= 90) return 'var(--report-green)';
      if (score >= 50) return 'var(--report-orange)';
      return 'var(--report-red)';
    },

    scoreOffset(score) {
      const circumference = 251.3; // 2π × 40
      return circumference * (1 - (score || 0) / 100);
    },

    metricRatingClass(rating) {
      if (rating === 'Good') return 'report-good-pill';
      if (rating === 'Needs Work') return 'report-warning-pill';
      return 'report-poor-pill';
    },
  };
}
